import React from 'react';

const Community = () => {
  return (
    <div className='center'>This channel doesn't have any communities.</div>
  );
};

export default Community;
